import { Guid } from "guid-typescript";
import { PropertyDocument } from "src/app/interfaces/Index";
import { Service } from "./Service";

const endpoint = "PropertyDocument";
export const PropertyDocumentService = {
	endpoint,
	createSingle: async (data: PropertyDocument) => await Service.createSingle(endpoint, data),
	deleteSingleById: async (id: number) => await Service.deleteSingleById(endpoint, id),
	getAll: async () => await Service.getAll(endpoint),
	getSingleById: async (id: number) => await Service.getSingleById(endpoint, id),
	getSingleByLookupId: async (id: Guid) => await Service.getSingleByLookupId(endpoint, id),
	updateSingleById: async (id: number, data: PropertyDocument) => await Service.updateSingleById(endpoint, id, data)
}